import { useEffect } from "react"
import { useState } from "react"
import { useLocation } from "react-router-dom"
// import { sleep } from "./utilityFunctions"

/**
 * 
 * @param {string[]} paramList E.g. ['icp_number', 'status']
 * @returns {object} E.g. {icp_number: '000545692NR850', status: 'Active'}
 * 
 * Gets the named parameters from the query string on the current page.
 */
export function useGetParams(paramList) {

    // console.log('useGetParams paramList', paramList)

    // const [getParamsObject, setGetParamsObject] = useState({})
    const [getParamsObject, setGetParamsObject] = useState()
    // const [isLoading, setIsLoading] = useState(true)
    const location = useLocation()


    useEffect(() => {
        // console.log('useGetParams useEffect LOCATION', location)
        const searchParams = new URLSearchParams(location.search)
        // console.log('useGetParams useEffect searchParams', searchParams)
        const newParams = {}
        paramList.forEach(p => {
            const thisGetParameterValue = searchParams.get(p)
            newParams[p] = thisGetParameterValue
        })
        setGetParamsObject((existingParams) => {
            const isStillTheSame = JSON.stringify(existingParams || {}) === JSON.stringify(newParams)
            // console.log('useGetParams setGetParamsObject isStillTheSame', isStillTheSame)
            // console.log('useGetParams setGetParamsObject existingParams', existingParams)
            // console.log('useGetParams setGetParamsObject newParams', newParams)
            return isStillTheSame ? existingParams : newParams
        })
        // if (location.pathname) {
        //     setIsLoading(false)
        // }
    }, [location, paramList])

    // console.log('useGetParams returning getParamsObject', getParamsObject)
    // sleep(2000)
    // return { getParams: getParamsObject, isLoading }
    return getParamsObject
}